var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiverIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02503 5.77752L3.78532 4.01725C4.1444 3.65817 4.26865 3.12761 4.12342 2.64101C4.00986 2.26051 3.88191 1.80309 3.79687 1.41195C3.71821 1.05018 3.40076 0.75 3.03054 0.75H2.02503C1.28459 0.75 0.676534 1.35256 0.757754 2.08853C1.37519 7.68305 5.81739 12.1252 11.4119 12.7427C12.1479 12.8239 12.7505 12.2158 12.7505 11.4754V10.4699C12.7505 10.0997 12.4491 9.79598 12.0848 9.72971C11.683 9.65665 11.2579 9.53691 10.9022 9.42351C10.3912 9.26058 9.82319 9.37512 9.44399 9.75431L7.72293 11.4754",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiverIc);
export default __webpack_public_path__ + "static/media/receiver_ic.f74752e643c1af4bbec0b7769b4d6b1e.svg";
export { ForwardRef as ReactComponent };